import { AppConfig } from "../../app-services/config/config.app";
import { Enums } from '../../enums/enums';
import { AbstractEndpoints, IAdvertisementEndpoints, IAuthorizationEndpoints, IAzureStorageEndpoints, ICampaignInsightsEndpoints, ICampaignsEndpoints, IMenuEndpoints, INotificationEndpoints, IOrganizationEndpoints, ITokenEndpoints } from "./endpoints.service.abstract";

export class Endpoints implements AbstractEndpoints {

    advertisement: IAdvertisementEndpoints;
    authorization: IAuthorizationEndpoints;
    azureStorage: IAzureStorageEndpoints;
    campaigns: ICampaignsEndpoints;
    campaignInsights: ICampaignInsightsEndpoints;
    menu: IMenuEndpoints;
    notifications: INotificationEndpoints;
    organization: IOrganizationEndpoints;
    token: ITokenEndpoints;

    constructor(appConfig: AppConfig) {

        this.advertisement = {
            deleteAdvertisement: (organizationId: string, advertisementId: string) => `${appConfig.apiBaseURLs.campaigns}/api/DeleteAdvertisement?organizationId=${organizationId}&advertisementId=${advertisementId}`
        }

        this.authorization = {
            login: 'https://{tenant-name}.b2clogin.com/{tenantId}/B2C_1A_signin',
            passwordReset: 'https://{tenant-name}.b2clogin.com/{tenantId}/B2C_1A_password_reset',
            profileEdit: 'https://{tenant-name}.b2clogin.com/{tenantId}/B2C_1A_profile_edit',
            signup: 'https://{tenant-name}.b2clogin.com/{tenantId}/B2C_1A_signup',
            loginRedirect: 'http://localhost:4200/',
            registerRedirect: 'http://localhost:4200/new-user-wizard'
        };

        this.azureStorage = {
            base:  `${appConfig.azureStorage.storageURL}/${appConfig.azureStorage.baseContainerName}`
        };

        this.campaigns = {
            campaignConfig: (organizationId: string, campaignId: string): string => {
                return `${appConfig.azureStorage.storageURL}/${appConfig.azureStorage.baseContainerName}/${organizationId}/${campaignId}/${appConfig.azureStorage.campaignFileName}`;
            },
            campaignRedirectFile: (organizationId: string, campaignId: string): string => {
                return `${appConfig.azureStorage.storageURL}/${appConfig.azureStorage.baseContainerName}/${organizationId}/${campaignId}/${Enums.FileNames.REDIRECT_CAMPAIGN}`;
            },
            campaignSubscriptionFile: (organizationId: string, campaignId: string): string => {
                return `${appConfig.azureStorage.storageURL}/${appConfig.azureStorage.baseContainerName}/${organizationId}/${campaignId}/${appConfig.azureStorage.subscriptionsFilename}`;
            }
        };

        this.campaignInsights = {
            getPageViews: (url: string, startDate: Date, endDate: Date): string => {
                return `${appConfig.apiBaseURLs.applicationInsights}/api/GetPageViews?searchValue=${url}&startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`;
            }
        };

        this.menu = {
            loadMenuFile: (organizationId: string, campaignId: string): string => {
                return `${appConfig.azureStorage.storageURL}/${appConfig.azureStorage.baseContainerName}/${organizationId}/${campaignId}/${appConfig.azureStorage.menuFileName}`;
            }
        };

        this.notifications = {
            sendNotification: `${appConfig.apiBaseURLs.campaigns}/api/SendNotification`
        }

        this.organization = {
            updateOrganization: `${appConfig.apiBaseURLs.cosmosDB}/api/UpdateUserOrganizations`,
            organizationSubscriptionFile: (organizationId: string): string => {
                return `${appConfig.azureStorage.storageURL}/${appConfig.azureStorage.baseContainerName}/${organizationId}/${appConfig.azureStorage.subscriptionsFilename}`;
            }
        }

        this.token = {
            getSASCRUDToken: (containerName?: string): string => `${appConfig.apiBaseURLs.campaigns}/api/GetSASTokenForContainer?containerName=${containerName ?? appConfig.azureStorage.baseContainerName}`,
            getSASAppendToken: (fileName: string) => `${appConfig.apiBaseURLs.anonymousAccess}/api/GetSASTokenToAppendView?containerName=${appConfig.azureStorage.baseContainerName}&file=${fileName}`,
            getSASTokenForFolder: (containerName?: string, folderName?: string): string => `${appConfig.apiBaseURLs.anonymousAccess}/api/GetSASTokenForFolder?containerName=${containerName}&folderPath=${folderName}`
        }

    }
}
